import requiredFieldConfigRaw from '../../data/requiredFieldConfig';
import DisclosurePageRenderer from './DisclosurePageRenderer';

const RequestDisclosures = () => {
    const config = requiredFieldConfigRaw.Pages.find(
        (p) => p.Page === 'Send Disclosures'
    );
    return (
        <DisclosurePageRenderer
            pageName="Request Disclosures"
            config={config}
            redirectPage="Disclosures"
        />
    );
};

export default RequestDisclosures;
